<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">库名：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="库名"
                clearable
                v-model="queryData.position"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">入库日期：</div>
            <div class="search-form-controller">
              <el-date-picker
                style="width: 100%"
                type="date"
                size="mini"
                placeholder="入库日期"
                v-model="queryData.instoreDate"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-autocomplete
            style="margin-left: 20px"
            size="mini"
            popper-class="my-autocomplete"
            v-model="queryData.product_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入样本册"
            @select="handleSelect"
            @blur="handblur"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <span>{{ item.name }}</span>
            </template>
          </el-autocomplete>
          <el-button
            icon="el-icon-delete"
            size="mini"
            @click="deleteHandler"
          >删除样本册</el-button>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
          @row-dblclick="doubleClick"
        >
          <el-table-column
            label="样本册"
            width="170"
            prop="sampleName"
            align="center"
          ></el-table-column>
          <el-table-column
            label="托盘号"
            prop="pt"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            label="库名"
            prop="position"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库数量"
            prop="instore_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="出库数量"
            prop="outstore_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="不良品数量"
            prop="reject_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="在库数量"
            prop="current_number"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="入库日期"
            prop="create_time"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="出库日期"
            prop="out_time"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
      <el-dialog
        :visible="isShow"
        :width="width"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :append-to-body="true"
        :show-close="false"
      >
        <div slot="title" class="dialog-title-container">
          <span class="title-label"><i class="el-icon-s-grid"></i>明细</span>
          <i class="el-icon-error" @click="close"></i>
        </div>
        <div class="dialog-main-container">
          <el-table
            :data="dsDetail"
            size="mini"
            height="410px"
            style="width: 100%;"
            stripe
            border
            header-row-class-name="list-header-row"
            row-class-name="list-row"
          >
            <el-table-column
              label="类别"
              prop="category"
              align="center"
            ></el-table-column>
            <el-table-column
              label="库名"
              prop="position"
              align="center"
            ></el-table-column>
            <el-table-column
              label="数量"
              prop="number"
              align="center"
            ></el-table-column>
            <el-table-column
              label="不良品数量"
              prop="reject_number"
              align="center"
            ></el-table-column>
            <el-table-column
              label="员工"
              prop="employee"
              align="center"
            ></el-table-column>
            <el-table-column
              label="时间"
              prop="date"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
    <!--列表数据 结束-->
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      ds: [],
      dsDetail: [],
      queryData: {
        product_id: "",
        product_name: "",
        position: "",
        instoreDate:'',
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      isShow: false,
      width: "55%"
    };
  },
  created: function() {},
  mounted: function() {
    this.loadProduct();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 样本册搜索
    loadProduct: function() {
      let _this = this;
      _this.queryData.product_count = "";
      _this.get(_this.$apis.getInstoreProduct, {}, function(res) {
        _this.productList = res.data.dataList;
      });
    },
    querySearchAsync: function(queryString, cb) {
      this.product_check = "false";
      var results = queryString
        ? this.productList.filter(this.createStateFilter(queryString))
        : this.productList;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 500 * Math.random());
    },
    createStateFilter: function(queryString) {
      return product => {
        return product.name.indexOf(queryString) > -1;
      };
    },
    handleSelect: function(item) {
      let _this = this;
      _this.product_check = "true";
      _this.queryData.product_name = item.name;
      _this.queryData.product_id = item.id;
      _this.loadData();
    },
    handleIconClick: function(ev) {
      console.log(ev);
    },
    handblur: function() {
      if (this.product_check === "false") {
        this.queryData.product_name = "";
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getProductsSummaryList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.position = "";
        this.queryData.instoreDate = '';
      }
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      if (this.queryData.product_name === "") {
        this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        this.loadData();
      }
    },
    // 导出excel
    exportHandler: function() {
      let _this = this;
      if (_this.queryData.product_name === "") {
        _this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        _this.post(
          _this.$apis.exportProductsSummaryList,
          _this.queryData,
          function(res) {
            let _json = res.data;
            if (_json.fileUrl !== "") {
              window.location = _this.$apiroot + _json.fileUrl;
            } else {
              _this.$router.push({
                path: "/"
              });
            }
          }
        );
      }
    },
    // 删除样本册
    deleteHandler: function() {
      let _this = this
      if (_this.queryData.product_name === "") {
        _this.$message({
          type: "error",
          message: "请先选择样本册"
        });
        return false;
      } else {
        _this.$confirm('确定删除 ' + _this.queryData.product_name+' ?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let _params = {
            product_name: _this.queryData.product_name
          };
          _this.post(_this.$apis.delSample,_params,function(res) {
              let _json = res.data;
              if (_json.status === "ok") {
                _this.loadData();
                _this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              } else {
                _this.$message({
                  type: "error",
                  message: "无数据更新!"
                });
              }
            }
          );
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    doubleClick: function(row, column, event) {
      this.isShow = true;
      this.dsDetail = [];
      this.loadDetailData(row);
    },
    loadDetailData: function(row) {
      let _this = this;
      _this.post(_this.$apis.getProductsDetailData, row, function(res) {
        let _json = res.data;
        _this.dsDetail = _json.datalist;
      });
    },
    close: function() {
      this.isShow = false;
    }
  },
  components: {}
};
</script>
